// extracted by mini-css-extract-plugin
module.exports = {"user":"UserInput_user__3MMV1","row_1":"UserInput_row_1__2YqGh","row_2":"UserInput_row_2__S9L87"};